import {
    GetTransferListResponseDto,
    TransferFilters,
    TransferHistory,
    TransferHistoryDto,
} from '../types/transfer.types';

export const formatAmount = (amount: number | undefined | null): string => {
    if (amount === undefined || amount === null) return '-';
    return amount.toLocaleString('ko-KR') + '원';
};

export const transferHistoryFromDto = (dto: TransferHistoryDto): TransferHistory => ({
    seqNo: dto.seqNo,
    processDate: dto.processDate || '',
    suppId: dto.suppId || '',
    suppName: dto.suppName || '',
    transferAmt: dto.transferAmt || 0,
    headBalanceAfter: dto.headBalanceAfter || 0,
    suppBalanceAfter: dto.suppBalanceAfter || 0,
    briefs: dto.briefs || '',
    insUser: dto.insUser || '',
});

export const transferHistoryListFromDto = (
    response: GetTransferListResponseDto
): TransferHistory[] => {
    if (!response || !response.list || !Array.isArray(response.list)) {
        return [];
    }
    return response.list.map(transferHistoryFromDto);
};

export const createDefaultTransferFilters = (): TransferFilters => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        startDate: formatDate(startOfMonth),
        endDate: formatDate(today),
        suppId: '',
    };
};
